import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';
import zhTW from 'antd/locale/zh_TW';

export interface CommonResponseObj {
  code: number;
  data: any;
  msg: string;
}

export interface SelectOptionType {
  value: number | string;
  label: string;
  disabled?: boolean;
}

export interface PaginationParam {
  total?: number;
  current: number;
  size: number;
}

export interface ActionDropdownItemType {
  key: string;
  icon: React.ReactElement;
  label: string;
  onClick: () => void;
}

export enum ModalModes {
  VIEW = 'VIEW',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  NONE = 'NONE',
}

export const OperationTypeList = [
  { value: 3, label: 'Model.ChargingOperator' },
  { value: 2, label: 'Model.Community' },
  { value: 5, label: 'Model.ParkingLot' },
  { value: 4, label: 'Model.GovernmentProject' },
];

export const ProductModeList = [
  { value: 1, label: 'Model.PublicChargingMode' },
  { value: 2, label: 'Model.PrivateChargingMode' },
];

export type DayOfWeek =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY';

export const enum Region {
  TAIWAN = 'TAIWAN',
  JAPAN = 'JAPAN',
  KOREA = 'KOREA',
}

export const RegionOptions = [
  {
    value: Region.TAIWAN,
    label: 'GiftCardList.Taiwan',
  },
  {
    value: Region.JAPAN,
    label: 'GiftCardList.Japan',
  },
  {
    value: Region.KOREA,
    label: 'GiftCardList.Korea',
  },
];

export const LanguageMap = {
  zhTW: { label: '繁體中文', antd: zhTW, dayjs: 'zh-tw', i18n: 'zhTW' },
  enUS: { label: 'English', antd: enUS, dayjs: 'en', i18n: 'en' },
  jaJP: { label: '日本語', antd: jaJP, dayjs: 'ja', i18n: 'ja' },
} as const;

export type LanguageKey = keyof typeof LanguageMap;
